export default "__VITE_ASSET__Bk$H_q2f__"